import baseAPI from "@/api/base";
import {
    EditBankAccount,
    GetBankAccounts,
    RegisterBankAccount,
    ToggleBankAccountIsActive,
} from "@/dtos/recipient_account.dto";
import {
    BANK_ACCOUNT_URL,
    TOGGLE_BANK_ACCOUNT_IS_ACTIVE_URL,
} from "@/utils/urls";
import { AxiosResponse } from "axios";

class BankAccount {
    // GET /recipient-account — the bank accounts of the signed-in user's org.
    static getBankAccounts = async (
        params: GetBankAccounts,
    ): Promise<AxiosResponse> => {
        // `searchTerm` is a client-side filter only — never forward it to the API.
        const { searchTerm, ...query } = params ?? {};
        return baseAPI.get(BANK_ACCOUNT_URL, { params: query });
    };

    // POST /recipient-account — register a new bank account.
    static registerBankAccount = async (
        body: RegisterBankAccount,
    ): Promise<AxiosResponse> => {
        return baseAPI.post(BANK_ACCOUNT_URL, body);
    };

    // PUT /recipient-account — update an existing bank account.
    static editBankAccount = async (
        body: EditBankAccount,
    ): Promise<AxiosResponse> => {
        return baseAPI.put(BANK_ACCOUNT_URL, body);
    };

    // PATCH /recipient-account/isActive — flip the active flag.
    static toggleIsActive = async (
        body: ToggleBankAccountIsActive,
    ): Promise<AxiosResponse> => {
        return baseAPI.patch(TOGGLE_BANK_ACCOUNT_IS_ACTIVE_URL, body);
    };

    // DELETE /recipient-account/:id — soft-delete a bank account.
    static deleteBankAccount = async (id: string): Promise<AxiosResponse> => {
        return baseAPI.delete(`${BANK_ACCOUNT_URL}/${id}`);
    };
}

export default BankAccount;
